import { useState } from "react";
import { motion } from "framer-motion";
import BeforeAfterSlider from "@/components/site/BeforeAfterSlider";
import { fileUrl } from "@/lib/api";

const FALLBACK = [
  {
    id: "demo1",
    title: "Wohnzimmer Renovation",
    description: "Komplette Neugestaltung in warmen Tönen",
    beforeSrc: "https://images.unsplash.com/photo-1503594384566-461fe158e797?auto=format&fit=crop&w=1600&q=80",
    afterSrc: "https://images.pexels.com/photos/13141770/pexels-photo-13141770.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
];

export default function BeforeAfter({ items }) {
  const list = items && items.length > 0
    ? items.map((it) => ({
        id: it.id,
        title: it.title,
        description: it.description,
        beforeSrc: fileUrl(it.before_path),
        afterSrc: fileUrl(it.after_path),
      }))
    : FALLBACK;

  const [index, setIndex] = useState(0);
  const current = list[index];

  return (
    <section id="vorher-nachher" data-testid="before-after-section" className="py-24 sm:py-32 bg-sand-100">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.25em] text-sage font-bold mb-6" data-testid="ba-overline">Vorher / Nachher</p>
            <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-stone-900 leading-tight" data-testid="ba-headline">
              Schieben und <em className="text-clay">staunen</em>.
            </h2>
            <p className="text-stone-600 mt-4 text-base">Bewegen Sie den Regler, um die Verwandlung zu sehen.</p>
          </div>
          {list.length > 1 && (
            <div className="flex flex-wrap gap-2" data-testid="ba-selector">
              {list.map((it, i) => (
                <button
                  key={it.id}
                  onClick={() => setIndex(i)}
                  data-testid={`ba-tab-${i}`}
                  className={`px-4 py-2 text-sm rounded-sm transition-colors duration-200 border ${
                    i === index
                      ? "bg-stone-900 text-sand-100 border-stone-900"
                      : "bg-transparent text-stone-700 border-sand-300 hover:border-stone-900"
                  }`}
                >
                  {it.title || `Projekt ${i + 1}`}
                </button>
              ))}
            </div>
          )}
        </div>

        <motion.div
          key={current.id}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <BeforeAfterSlider beforeSrc={current.beforeSrc} afterSrc={current.afterSrc} />
          {(current.title || current.description) && (
            <div className="mt-6 max-w-2xl">
              {current.title && <h3 className="font-display text-2xl text-stone-900" data-testid="ba-current-title">{current.title}</h3>}
              {current.description && <p className="text-stone-600 mt-2">{current.description}</p>}
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
}
